(function initLoadingStore() {
	if (window.LoadingStore) return;

	let _loading = false;
	const subs = new Set();

	const DEBUG = !!localStorage.getItem("debug:loading");

	function setLoading(next) {
		const val = !!next;
		if (val === _loading) return;
		_loading = val;
		if (DEBUG) console.log("[LoadingStore]", val ? "loading" : "idle");
		subs.forEach((fn) => {
			try {
				fn(_loading);
			} catch (e) {
				/* noop */
			}
		});
	}

	function subscribe(fn) {
		if (typeof fn !== "function") return () => {};
		subs.add(fn);
		try {
			fn(_loading);
		} catch (e) {}
		return () => subs.delete(fn);
	}

	function whenFalseOnce() {
		return new Promise((resolve) => {
			if (!_loading) return resolve(false);
			const off = subscribe((val) => {
				if (!val) {
					off();
					resolve(true);
				}
			});
		});
	}

	window.LoadingStore = Object.freeze({
		get value() {
			return _loading;
		},
		setLoading,
		subscribe,
		whenFalseOnce,
	});
})();
